export default __webpack_public_path__ + "static/media/diet.6d38e9e1.jpg";